<template>
    <div class="container text-md-start text-center mb-4 mt-5">
        <div class="row align-items-center">

            <!-- Text -->
            <div class="col-xl-6 col-md-7 order-md-1 mb-4">
                <h1 class="display-1 mb-sm-4 mt-n4 mt-sm-n5">Erro 403</h1>
                <p class="mb-md-5 mb-4 mx-md-0 mx-auto pb-2 lead">
                    {{ msg || 'Acesso Negado! Você não tem permissão para acessar este conteúdo. Se você acredita que deveria ter acesso, entre em contato com o administrador do sistema.' }}
                </p>
                <!--
                    Era `href="..\home"`, com BARRA INVERTIDA e caminho relativo: o único
                    caminho de saída da tela de erro dependia de o navegador normalizar a
                    barra e de a rota atual ter a profundidade esperada. Numa rota mais
                    funda o link levava para fora do sistema. Sair de uma página de erro é
                    o caso em que a rota de escape não pode ser frágil.
                -->
                <router-link to="/home" class="btn btn-lg btn-primary shadow-primary w-sm-auto w-100">
                    <i class="bx bx-home-alt me-2 ms-n1 lead" aria-hidden="true"></i>
                    Ir para página Inicial
                </router-link>
            </div>

            <!--
                Ilustração decorativa.

                `aria-hidden="true"`: o renderizador SVG do lottie-web produz um <svg> sem
                nome nem papel. A ilustração não acrescenta informação nenhuma ao texto ao
                lado, então some da árvore de acessibilidade em vez de virar um nó anônimo
                no meio da leitura (WCAG 1.1.1 — imagem decorativa).

                `:loop="false"`: estava em laço INFINITO. Movimento que dura mais de 5
                segundos, em paralelo com o conteúdo, precisa de um jeito de pausar, parar
                ou esconder (WCAG 2.2.2, nível A) — e não havia nenhum. Tocar uma vez
                resolve o critério sem perder a ilustração.

                `:autoPlay="!movimentoReduzido"`: quem pede menos movimento no sistema
                operacional não recebe a animação (WCAG 2.3.3, AAA). O bloco
                `prefers-reduced-motion` da folha global NÃO alcança este caso: ele zera
                animação de CSS, e o lottie anima via JavaScript.

                Atenção ao nome da propriedade: é `autoPlay` (camelCase). O template
                antes trazia `autoplay` todo minúsculo, que o Vue não casa com a
                propriedade — ela caía como atributo solto na div e o componente usava o
                padrão dela (true). Ou seja, o atributo escrito ali nunca controlou nada.
            -->
            <div class="col-md-4 offset-xl-1 order-md-2" aria-hidden="true">
                <Vue3Lottie :animationData="animation" background="transparent" :speed="0.5" :loop="false"
                    :autoPlay="!movimentoReduzido"
                    style="max-width: 100%; height: auto;">
                </Vue3Lottie>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import animationData from '@/assets/json/animation-403-v1.json';
import { defineComponent } from "vue";

export default defineComponent({
    name: "AccessDenied",
    components: {
    },
    mounted() {
    },
    computed: {
        animation() {
            return animationData;
        },
        /**
         * Preferência de movimento reduzido do sistema operacional (WCAG 2.3.3, AAA).
         * Lido em JS porque o lottie anima por JavaScript: a regra
         * `@media (prefers-reduced-motion: reduce)` da folha global só alcança animação
         * de CSS.
         */
        movimentoReduzido(): boolean {
            return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        }
    },
    props: {
        msg: String,
    },
    methods: {

    },
});
</script>
<style lang="scss"></style>